<template>
    <form
        ref="form"
        :model="form"
        label-width="120px"
        @submit.prevent="onSubmit"
    >
        <div class="form-group text-left" v-if="showCodeField">
            <label>Monto $ RD {{ OrderStore.Amount }}</label>
        </div>
        <div class="form-group text-left" v-if="showCodeField">
            <label>Código de empleado</label>

            <input
                class="form-control"
                placeholder="Escribir el código del empleado..."
                type="password"
                name="code"
                v-validate="'required'"
                v-model.trim="form.code"
                @keypress.enter="onSubmit"
                autocomplete="off"
                required
            />
        </div>

        <div class="text-right">
            <el-button type="danger" @click="goHome">Cancelar</el-button>
            <el-button
                type="primary"
                @click="onSubmit"
                :icon="isLoading ? 'el-icon-loading' : ''"
            >
                {{ buttonText }}
            </el-button>
        </div>
    </form>
</template>

<script>
import { OrderStore } from "../OrderStore";
import router from "../router";

export default {
    props: {
        method: { type: Function },
        mode: {
            type: String,
            required: true,
            default: "identification",
        },
        showCancelButton: Boolean,
        buttonText: {
            type: String,
            required: true,
        },
        employee: {
            type: Object,
        },
    },
    data() {
        return {
            form: {},
            isLoading: false,
            OrderStore,
        };
    },
    computed: {
        //showIdField() {
        //    return this.formModes("identification").includes(this.mode);
        //},
        showCodeField() {
            return this.formModes("code").includes(this.mode);
        },
    },
    methods: {
        goHome() {
            router.push("/");

            this.method();
        },

        async onSubmit() {
            // On employee code submit

            await this.$validator.validateAll();

            if (this.form.code === "") {
                return this.$notify({
                    title: "Error",
                    message: "Llene todos los campos",
                    type: "error",
                });
            }

            if (this.isLoading) {
                return this.$notify({
                    title: "Loading",
                    message: "Cargando...",
                    type: "info",
                });
            }

            //if (this.showCodeField) {
            //    // user_id because is the Users model and not employee
            //    formData.id = this.employee.user_id;
            //}

            const formData = OrderStore.EmployeeCode
                ? { code: OrderStore.EmployeeCode }
                : {
                      ...this.form,
                  };

            this.authEmployee(formData);
        },
        formModes(principal) {
            return [principal, "full"];
        },

        authEmployee(userData) {
            this.isLoading = true;

            axios
                .post(`${API_URL}/client/auth`, userData)
                .then(({ data }) => {
                    OrderStore.EmployeeCode = userData.code; // Update EmployeeCode in the EmployeCodeStore state for the Confirm Order View

                    this.$emit("auth-response", data.auth);
                    this.form = {};
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.onAuthError(error);
                });
        },

        onAuthError() {
            this.isAuthenticated = false;
            this.isLoading = false;

            return this.$notify({
                title: "Error",
                message: "Cliente no esta vinculado a CashDepot.",
                type: "error",
            });
        },
    },
};
</script>
